import { createContext, useContext } from 'react';
import { theme } from 'antd';

export const COLOR_THEME_KEY = 'colorTheme';

export function readColorTheme() {
    try {
        return localStorage.getItem(COLOR_THEME_KEY) === 'dark' ? 'dark' : 'light';
    } catch {
        return 'light';
    }
}

export function writeColorTheme(value) {
    try {
        localStorage.setItem(COLOR_THEME_KEY, value === 'dark' ? 'dark' : 'light');
    } catch {
        // ignore
    }
}

export function antdTheme(mode) {
    if (mode === 'dark') {
        return {
            algorithm: theme.darkAlgorithm,
            token: {
                colorPrimary: '#3f8f10',
            },
            components: {
                Form: { marginLG: 8 },
                Table: { cellPaddingBlockSM: 2 },
            },
        };
    }
    return {
        algorithm: theme.defaultAlgorithm,
        token: {
            colorPrimary: '#2f6f00',
            colorPrimaryHover: '#2f6f00',
            colorPrimaryActive: '#2f6f00',
        },
        components: {
            Form: { marginLG: 8 },
            Table: {
                headerBg: '#fff',
                cellPaddingBlockSM: 2,
            },
            Button: {
                defaultBg: '#ffffff',
                defaultColor: '#2f6f00',
                defaultHoverBg: '#2f6f00',
                defaultHoverColor: '#ffffff',
            },
        },
    };
}

export const ColorThemeContext = createContext({
    colorTheme: 'light',
    setColorTheme: () => {},
});

export function useColorTheme() {
    return useContext(ColorThemeContext);
}
